module.exports = __webpack_public_path__ + "img/conn.405bff8c.png";